import {Box, Typography} from "@mui/material";

interface Props {
    lowLabel: string
    highLabel: string
    mobileEndpoints?: readonly [number, number]
}

function ScaleLabels({lowLabel, highLabel, mobileEndpoints}: Props) {
    if (!lowLabel.trim() && !highLabel.trim()) return null;

    return (
        <Box sx={{mt: 2, display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 2}}>
            {[lowLabel, highLabel].map((label, index) => (
                <Typography
                    key={index}
                    variant={'body1'}
                    color={'text.secondary'}
                    sx={{textAlign: index === 0 ? 'left' : 'right', overflowWrap: 'anywhere'}}
                >
                    {!!label && mobileEndpoints && (
                        <Box component={'span'} sx={{display: {xs: 'inline', sm: 'none'}, fontWeight: 600}}>
                            {mobileEndpoints[index]} · {' '}
                        </Box>
                    )}
                    {label}
                </Typography>
            ))}
        </Box>
    );
}

export default ScaleLabels;
